import { useNavigate, useRouteLoaderData } from "react-router-dom";

import JobSafetyAnalysis from "./JSAContent";
import type { Assignment } from "./types";
import { useAuthStore, User } from "../main/authStore";

export default function JSAForm() {
    const assignment = useRouteLoaderData("assignment") as Assignment;
    const navigate = useNavigate();
    const user = useAuthStore(state => state.user) as User;

    if (assignment.leadId !== user?.id) {
        return (
            <div className="p-3">
                <div className="alert alert-warning mb-3">
                    Only the assignment lead can complete JSA.
                </div>
                <button type="button" className="btn btn-outline-secondary" onClick={() => navigate("..")}>
                    Back
                </button>
            </div>
        );
    }

    return (
        <JobSafetyAnalysis
            formTitle="JOB SAFETY ANALYSIS"
            closeIt={() => navigate("..")}
            workId={assignment.workId}
            location={assignment.location}
            jobSafetyAnalysisContent={assignment.jobSafetyAnalysisContent || "{}"}
            assignmentId={assignment.id}
            projectName={assignment.projectName}
            nearestMedicalFacility={assignment.nearestMedicalFacility}
            laborCategory={assignment.laborCategory}
            userName={assignment.userName}
            adminLink=""
            mainLaborCategory=""
            setMainLaborCategory={() => {}}
            setMainLaborName={() => {}}
            mainLaborName=""
            helpers={{}}
            setHelpers={() => {}}
            formAssignmentId=""
            formId=""
        />
    );
}
